import {LoDashStatic} from "lodash";
import {removeInvalids} from "../../util/lodashExtensions.ts";
import IFilterService = angular.IFilterService;
import ILocationService = angular.ILocationService;

const _ = <LoDashStatic>require('lodash');
require('./searchForm.less');
const moment: any = require("moment");

export const ALL_WEEK_CONSTANT = 69;

class SearchformController {
    defaultDateFormat: string = "yyyy-MM-dd";
    searchDefinition;
    initialPageSetup = {pageNo: null, pageSize: null, sort: null};
    searchForm: ng.IFormController;
    oldLocParams: any;
    activeState;
    urlListener;
    weekSelectData;

    constructor(private $filter: IFilterService, private $location: ILocationService, private $scope, private urlService, private $state) {
    }

    $onInit() {
        if (Object.keys(this.$location.search()) && this.searchDefinition.searchParams && this.searchDefinition.searchParams['statuses']) {
            this.$location.search(this.searchDefinition.searchParams);
        }
        if (this.searchDefinition.useWeekSelect) {
            if (this.searchDefinition.useDefaultAllWeeks) {
                this.weekSelectData = new WeekSelectData(null, null, true);
            } else if (this.$location.search().deliveryDateFrom && this.$location.search().deliveryDateTo) {
                this.weekSelectData = new WeekSelectData(this.$location.search().deliveryDateFrom, this.$location.search().deliveryDateTo);
            } else {
                this.weekSelectData = new WeekSelectData();
            }
        }

        this.urlListener = this.$scope.$on('$locationChangeSuccess', () => {
            if (this.activeState === this.$state.current.name) {
                this.handleUrlParameters();
            }
        });

        this.$scope.$on('$emptyWeekData', () => this.emptyParams());

        this.activeState = angular.copy(this.$state.current.name);
        this.initialPageSetup.pageNo = this.searchDefinition.searchParams.pageNo;
        this.initialPageSetup.pageSize = this.searchDefinition.searchParams.pageSize;
        this.initialPageSetup.sort = this.searchDefinition.searchParams.sort;

        if (this.searchDefinition.useWeekSelect) {
            this.addDatesToLocation();
        }
        this.handleUrlParameters();
    }

    $onDestroy() {
        this.urlListener();
    }

    emptyParams() {
        this.weekSelectData.empty();
        this.$location.search({});
    }

    addDatesToLocation() {
        this.$location.search().deliveryDateFrom = this.formatDate(this.weekSelectData.fromDate);
        this.$location.search().deliveryDateTo = this.formatDate(this.weekSelectData.toDate);
    }

    formatDate(date, format?): string {
        return this.$filter('date')(date, format ? format : 'yyyy-MM-dd')
    }

    handleUrlParameters() {
        if (!this.$state.params['details']) {
            const locParams = this.urlService.getParsedSearchParams(this.searchDefinition);
            if (locParams && !_.isEmpty(locParams) && !_.isEqual(locParams, this.oldLocParams)) {
                this.oldLocParams = angular.copy(locParams);
                this.searchDefinition.searchParams = angular.copy(locParams);
                this.parseParamsWithFormatedDates();
                if (this.searchDefinition.activePredefinedSearch) {
                    this.searchDefinition.activePredefinedSearch.func(locParams);
                } else {
                    const paramsWithFormattedDates = this.getParamsWithFormattedDates();
                    this.searchDefinition.searchFunction(paramsWithFormattedDates);
                }
            }
        }
    }

    getParamsWithFormattedDates() {
        let params = angular.copy(this.searchDefinition.searchParams);
        _.forEach(params, (param, key) => {
            const isDate = _.findIndex(this.searchDefinition.fields, {name: key, type: 'date'}) > -1;
            if (isDate) {
                params[key] = this.formatDate(Date.parse(param), this.defaultDateFormat)
            }
        });
        return params;
    }

    parseParamsWithFormatedDates() {
        let searchDefParams = this.searchDefinition.searchParams;
        _.forEach(searchDefParams, (param, key) => {
            const isDate = _.findIndex(this.searchDefinition.fields, {name: key, type: 'date'}) > -1;
            if (isDate) {
                searchDefParams[key] = new Date(searchDefParams[key]);
            }
        });
    }

    search() {
        if (this.searchForm.$valid) {
            if (this.searchDefinition.useWeekSelect) {
                this.searchDefinition.searchParams.deliveryDateFrom = this.formatDate(this.weekSelectData.fromDate);
                this.searchDefinition.searchParams.deliveryDateTo = this.formatDate(this.weekSelectData.toDate);
            }
            this.searchDefinition.searchParams.pageNo = this.initialPageSetup.pageNo;
            if (!this.searchDefinition.searchParams.sort) {
                this.searchDefinition.searchParams.sort = this.initialPageSetup.sort;
            }
            const pageSize = this.$location.search().pageSize;
            this.searchDefinition.searchParams.pageSize = pageSize ? pageSize : this.initialPageSetup.pageSize;
            this.searchDefinition.searchParams = removeInvalids(this.searchDefinition.searchParams);
            const predefinedSearchParameters = _.map(this.searchDefinition.preDefinedSearches, (predef: any) => {
                return predef.name
            });
            this.searchDefinition.searchParams = _.omit(this.searchDefinition.searchParams, predefinedSearchParameters);

            const params = this.getParamsWithFormattedDates();
            if (Object.keys(params).length) {
                this.$location.search(params);
            } else {
                this.$location.search({search: true});
            }
        }
    }

    preDefinedParamsSearch(predefinedSearch) {
        if (!predefinedSearch.predefinedParams) {
            let params = {
                deliveryDateFrom: this.weekSelectData ? this.formatDate(this.weekSelectData.fromDate) : null,
                deliveryDateTo:  this.weekSelectData ? this.formatDate(this.weekSelectData.toDate) : null,
                pageNo: 0,
                pageSize: this.searchDefinition.searchParams.pageSize,
                sort: this.searchDefinition.searchParams.sort
            };
            params[predefinedSearch.name] = true;
            this.$location.search(params);
        } else {
            this.$location.search(predefinedSearch.predefinedParams);
        }
    }

    setDates() {
        if (this.weekSelectData.week && this.weekSelectData.year) {

            if (this.weekSelectData.week === ALL_WEEK_CONSTANT) {
                this.weekSelectData.fromDate = new Date(moment(new Date())
                    .year(this.weekSelectData.year)
                    .startOf('year').format('YYYY-MM-DD'));

                this.weekSelectData.toDate = new Date(moment(new Date())
                    .year(this.weekSelectData.year)
                    .endOf('year').format('YYYY-MM-DD'));

            } else {
                this.weekSelectData.fromDate = new Date(moment(new Date())
                    .year(this.weekSelectData.year)
                    .isoWeek(this.weekSelectData.week)
                    .startOf('isoweek').format('YYYY-MM-DD'));

                this.weekSelectData.toDate = new Date(moment(new Date()).year(this.weekSelectData.year)
                    .isoWeek(this.weekSelectData.week)
                    .endOf('isoweek').format('YYYY-MM-DD'));
            }
        }
    }

    yearChanged() {
        this.weekSelectData.numberOfWeeks = moment(new Date()).year(this.weekSelectData.year).isoWeeksInYear();
        if (this.weekSelectData.week === 53 && this.weekSelectData.numberOfWeeks === 52) {
            this.weekSelectData.week = 52;
        }
        this.setDates();
        this.weekSelectData.weekOptions = [];
        _.times(this.weekSelectData.numberOfWeeks, (i: number) => this.weekSelectData.weekOptions.push(i + 1));
    }
}

class WeekSelectData {
    week: number;
    year: number;
    numberOfWeeks: number;
    weekOptions: Array<number> = [];
    yearOptions: Array<number> = [];
    fromDate: Date;
    toDate: Date;

    constructor(fromDate?, toDate?, useAllWeeks?) {
        if ((fromDate && toDate && moment(new Date(toDate)).diff(moment(new Date(fromDate)), 'days') > 8) || useAllWeeks) {
            this.week = ALL_WEEK_CONSTANT;
        }
        if (this.week !== ALL_WEEK_CONSTANT) {
            this.week = moment(fromDate ? new Date(fromDate) : new Date()).isoWeek();
        }
        this.year = moment(fromDate ? new Date(fromDate) : new Date()).year();
        this.numberOfWeeks = moment(new Date()).isoWeek(this.week).year(this.year).isoWeeksInYear();

        if (this.week === ALL_WEEK_CONSTANT) {
            this.fromDate = new Date(moment(new Date())
                .year(this.year)
                .startOf('year').format('YYYY-MM-DD'));

            this.toDate = new Date(moment(new Date())
                .year(this.year)
                .endOf('year').format('YYYY-MM-DD'));

        } else {
            this.fromDate = fromDate ? fromDate : new Date(moment(new Date()).year(this.year).isoWeek(this.week).startOf('isoweek').format('YYYY-MM-DD'));
            this.toDate = toDate ? toDate : new Date(moment(new Date()).year(this.year).isoWeek(this.week).endOf('isoweek').format('YYYY-MM-DD'));
        }

        _.times(this.numberOfWeeks, (i: number) => this.weekOptions.push(i + 1));
        _.times(150, (i: number) => this.yearOptions.push(2000 + i));
    }

    empty() {
        this.week = null;
        this.year = null;
        this.numberOfWeeks = null;
        this.fromDate = null;
        this.toDate = null;
    }
}

class SearchformOptions implements ng.IComponentOptions {
    bindings: any = {
        searchDefinition: '='
    };
    controller: string = 'rkcSearchformController';
    controllerAs: string = "c";
    template: any = require('./searchForm.html');
}

rkcApp.controller("rkcSearchformController", ['$filter', '$location', '$scope', 'urlService', '$state', function ($filter, $location, $scope, urlService, $state) {
    return new SearchformController($filter, $location, $scope, urlService, $state);
}])
    .component("rkcSearchform", new SearchformOptions())
;



/** WEBPACK FOOTER **
 ** ./src/app/components/searchform/searchForm.ts
 **/